import Component from './style-provider.component';

export default Component;
